import { useContext } from 'react';

import { AnalyticsContext } from '../context';
import { selectAnalyticsGlobals } from '../selectors';

import { useGetViewValues } from './getViewValues';
import { trackPageView } from './trackPageView';

type TrackingProps = Record<string, unknown>;

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);
  const viewValues = useGetViewValues();
  if (context === undefined) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }

  const { view, link, store } = context;

  const trackView = (pageName: string, params?: TrackingProps) => {
    trackPageView(store, view, pageName, {
      ...viewValues,
      ...params,
    });
  };

  const trackLink = (eventName: string, params?: TrackingProps) => {
    link(eventName, {
      ...selectAnalyticsGlobals(store.getState()),
      ...viewValues,
      ...params,
    });
  };

  return { trackView, trackLink };
};
